// extracted by mini-css-extract-plugin
export default {"bottomDivider":"ActivitySection_bottomDivider__s1Hju","children":"ActivitySection_children__nB7eG"};